module.exports = __webpack_public_path__ + "img/52114128_L.11272bd4.png";